<div [ngClass]="item.class" [class.markets-visible]="item.toggleMarkets">
    @if (hasFavorites && item.sportId) {
        <div class="favourites">
            <ms-favourite-league-toggle [name]="item.name" [id]="item.id" [sport]="item.sportId" />
        </div>
    }
    @if (!item.hidden && !hideHeader) {
        <ms-item
            id="item-{{ item.type }}-{{ item.id }}"
            class="header-item"
            [class.item-expanded]="item.expanded"
            [class.item-selected]="item.selected"
            [class.item-loading]="item.loading"
            [class.us-logo]="showCompetitionLogo"
            [icon]="item.icon"
            [count]="item.expanded ? undefined : item.count"
            [arrow]="item.collapsible"
            (click)="clickItem($event, item)">
            <ng-container item-title>
                @if (item.name) {
                    <ms-inline-tooltip>
                        <span #tooltipContent>{{ item.name }}</span>
                    </ms-inline-tooltip>
                }
                @if (shouldShowMarketsToggle) {
                    <ms-inline-tooltip item-title [applyClass]="'toggle-markets-tooltip-msg'" [showOnlyIfOverflowed]="false">
                        <div class="toggle-markets" (click)="onToggleMarkets($event, item)">
                            <vn-icon class="tree-toggle-icon" size="13" [name]="item.toggleMarkets ? 'sports-circle-minus' : 'sports-circle-plus'" />
                        </div>
                        <div #tooltipContent class="inline-content-tooltip">
                            {{
                                item.toggleMarkets
                                    ? sitecoreEventDetails.eventDetails.LeftNavHideBets
                                    : sitecoreEventDetails.eventDetails.LeftNavDisplayBets
                            }}
                        </div>
                    </ms-inline-tooltip>
                }
                @if (showCompetitionLogo) {
                    <ms-competition-logo [sportId]="item.sportId" [leagueId]="item.id" [imageProfile]="item.imageProfile" />
                }
            </ng-container>
        </ms-item>
    }

    @if (showPlaceholder) {
        <div>
            <div class="tree-loading-wrapper" [msTreeDisplayAfter]="loadingIndicatorDelay">
                @for (placeholder of placeholderArray; track placeholder) {
                    <div class="tree-event-loading"></div>
                }
            </div>
        </div>
    }

    @if (item.expanded && children.length) {
        <div>
            @for (subItem of children; track trackItemsByFn($index, subItem)) {
                @if (!item.hidden) {
                    <ms-tree-item
                        [item]="subItem"
                        (toggle)="toggleItem(subItem)"
                        (toggleMarkets)="onToggleMarkets(undefined, subItem)"
                        (selectEvent)="onSelectEvent($event)" />
                }
            }
        </div>
    }

    @if (!showPlaceholder && item.events) {
        <div class="tree-events">
            @for (event of item.events; track trackEventsByFn($index, event)) {
                @if (!event.hidden) {
                    <div class="event-item" [class.selected]="event.selected">
                        <ms-tree-event
                            [showMarkets]="event.showMarkets"
                            [attr.id]="htmlEventId(event.data)"
                            [event]="event"
                            [leftNavType]="item.leftNavType"
                            [updatedFavourites]="updatedFavourites"
                            [hideFavourites]="item.hideFavorites"
                            (select)="onSelectEvent(event.data)" />
                    </div>
                }
            }
        </div>
    }
</div>
